import { MutationTree } from 'vuex';
import { IProjectState } from './types';
import { IProject } from '~/types/project';
import { IEpisodeWatchProgress, IEpisodeWatchSuggestion } from '~/types/series';

export const mutations: MutationTree<IProjectState> = {
  updateProject(projectState: IProjectState, project: IProject) {
    if (project) {
      const modifyProjects = { ...projectState.projects };
      modifyProjects[project.slug] = project;
      projectState.projects = modifyProjects;
    }
  },
  updateProjectEpisodeWatchProgress(
    projectState: IProjectState,
    watchProgress: Record<string, IEpisodeWatchProgress>,
  ) {
    projectState.episodeWatchProgress = watchProgress;
  },
  updateProjectWatchSuggestion(
    projectState: IProjectState,
    episodeWatchSuggestion: IEpisodeWatchSuggestion,
  ) {
    projectState.episodeWatchSuggestion = episodeWatchSuggestion;
  },
  updateCurrentVideo(projectState: IProjectState, videoSlug: string) {
    projectState.currentVideoSlug = videoSlug;
  },
  updateShowingVideo(projectState: IProjectState, showVideo: boolean) {
    projectState.showingVideo = showVideo;
  },
  updateViewingRestrictions(
    projectState: IProjectState,
    newViewingRestrictions: Record<string, boolean>,
  ) {
    projectState.viewingRestrictions = {
      ...projectState.viewingRestrictions,
      ...newViewingRestrictions,
    };
  },
  updateContinueRzrEp1AfterUA(
    projectState: IProjectState,
    continueVideo: boolean,
  ) {
    projectState.continueRzrEp1AfterUA = continueVideo;
  },
};
